import { render, staticRenderFns } from "./Treatment.vue?vue&type=template&id=775e7a91"
import script from "./Treatment.vue?vue&type=script&lang=js"
export * from "./Treatment.vue?vue&type=script&lang=js"
import style0 from "./Treatment.vue?vue&type=style&index=0&id=775e7a91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports